<template>
  <v-row class="page-breadcrumb">
    <v-col cols="12" sm="12" class="pa-0">
      <v-card class="px-2 elevation-0 breadcrumb-card">
        <v-toolbar dense flat class="transparent pa-0" height="40px">
          <v-toolbar-title class="pt-3">
            <span class="text--primary font-weight-semibold">{{ title }}</span>
          </v-toolbar-title>
          <v-toolbar-title
            slot="extension"
            class="toobar-extension transparent pb-3"
          >
            <v-breadcrumbs
              v-if="breadcrumbs && breadcrumbs.length"
              :items="breadcrumbs"
              class="pa-0"
            >
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
            </v-breadcrumbs>

            <slot></slot>
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <div v-if="$slots.actions" class="breadcrumb-actions">
          <slot name="actions"></slot>
        </div>
        <div v-if="$slots.below" class="px-1 pb-3">
          <slot name="below"></slot>
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: 'BaseBreadcrumb',
  props: {
    title: String,
    breadcrumbs: Array,
    icon: String
  },
  data: () => ({})
}
</script>
<style lang="scss">
.page-breadcrumb {
  margin: -24px -25px 27px -25px;
}
.breadcrumb-card {
  position: relative;
}
.breadcrumb-actions {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>
